import React, { Component } from 'react'
import { Button, Dialog, IconButton, Paper, Typography, withStyles } from '@material-ui/core'
import { createSettingsEnterpriseCategoryAction, deleteSettingsEnterpriseCategoryAction, editSettingsEnterpriseCategoryAction, getSettingsEnterpriseCategoriesAction } from '../../../Actions/SettingsActions'
import { connect } from 'react-redux'
import { Add, Delete, Edit } from '@material-ui/icons'
import TextInput from '../../../Shared/Inputs/TextInput'
import autobind from '../../../Utils/autobind'
import SubmitButton from '../../../Shared/SubmitButton'
import LoaderAnimator from '../../../Shared/LoaderAnimator'
import SelectInput from '../../../Shared/Inputs/SelectInput'

const style = theme => ({
  title: {
    padding: 12,
    background: theme.palette.primary.main,
    color: "white",
    maxWidth: 700
  },
  container: {
    padding: 12
  },
  card: {
    margin: '24px 0'
  },
  category: {
    position: 'relative',
    "@media (max-width:500px)": {
      width: '100%'
    },
    width: 300,
    height: 150,
    overflow: 'hidden',
    background: '#FFF',
    borderRadius: "0 12px 12px 12px",
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      height: 100,
      width: 100,
      transform: "translate(-50%, -50%) rotate(45deg)",
      background: "#f2f3f8"
    }
  },
  subtitle: {
    padding: 12,
    background: theme.palette.primary.main,
    color: "white",
  },
  categoryContainer: {
    padding: 12,
    "@media (max-width:500px)": {
      width: '100%'
    },
    width: 300,
    height: 150,
  },
  categoryName: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    width: '60%'
  },
  buttons: {
    position: 'absolute',
    display: 'flex',
    top: 6,
    right: 6,
    alignItems: 'center'
  },
  addCategory: {
    maxWidth: 700,
    margin: 'auto',
    marginTop: 24
  },
  form: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    '& > button': {
      marginLeft: 12,
      height: 50
    }
  },
  categories: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialogForm: {
    padding: 12
  },
  submitButtons: {
    padding: 12,
    textAlign: 'end',
    '& > *': {
      marginLeft: 12
    }
  }
})

class EnterpriseDocuments extends Component {
  constructor() {
    super()
    this.state = {
      params: {
        frequency: 2
      },
      openDialog: false,
      editParams: {
        frequency: 2
      },
      openWarning: false,
      category: {},
      loading: true
    }
    autobind(EnterpriseDocuments, this)
  }

  componentDidMount() {
    const { getSettingsEnterpriseCategories } = this.props
    getSettingsEnterpriseCategories().then(() => this.setState({ loading: false }))
  }

  handleChange(event) {
    const { target } = event
    const { params } = this.state
    params[target.name] = target.value
    this.setState({ params })
  }

  handleChangeEdit(event) {
    const { target } = event
    const { editParams } = this.state
    editParams[target.name] = target.value
    this.setState({ editParams })
  }

  handleCreate() {
    const { createSettingsEnterpriseCategory } = this.props
    const { params } = this.state
    const body = {
      ...params,
    }
    this.setState({ params: {} })
    createSettingsEnterpriseCategory(body)
  }

  handleOpenDialog() {
    this.setState({ openDialog: !this.state.openDialog })
  }

  handleEdit(category) {
    return () => {
      this.setState({
        openDialog: true, editParams: {
          ...this.state.editParams,
          name: category.name,
          cut_day: category.cut_day,
          frequency: category.frequency,
          id: category.id
        }
      })
    }
  }

  handleSaveEdit() {
    const { editSettingsEnterpriseCategory } = this.props
    const { editParams } = this.state
    const body = {
      ...editParams,
    }
    editSettingsEnterpriseCategory(body)
    this.setState({ openDialog: false })
  }

  handleOpenWarning() {
    this.setState({ openWarning: !this.state.openWarning })
  }

  handleDelete(category) {
    return () => {
      this.setState({ openWarning: true, category })
    }
  }

  handleSendDelete() {
    const { deleteSettingsEnterpriseCategory } = this.props
    const { category } = this.state
    const body = {
      id: category.id
    }
    deleteSettingsEnterpriseCategory(body)
    this.setState({ openWarning: false })
  }

  renderCategories() {
    const { settings, classes } = this.props
    const allCategories = settings.base_documents.all || []
    return allCategories.map(category => {
      return (
        <div className={classes.categoryContainer} key={category.id}>
          <div className={classes.category}>
            <Typography variant="h3" className={classes.categoryName}>{category.name}</Typography>
            <div className={classes.buttons}>
              <IconButton size="small" onClick={this.handleEdit(category)}>
                <Edit />
              </IconButton>
              <IconButton size="small" onClick={this.handleDelete(category)}>
                <Delete />
              </IconButton>
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    const { classes } = this.props
    const { params, openDialog, editParams, openWarning, category, loading } = this.state
    return (
      <div className={classes.container}>
        <Typography variant="h1">Carpetas de documentos de Empresa</Typography>

        <Paper className={classes.addCategory} square>
          <Typography className={classes.subtitle} variant="h2">Agregar Carpeta</Typography>
          <div className={classes.form}>
            <TextInput label="Nombre Carpeta" value={params.name} name="name" onChange={this.handleChange} />
          </div>
          <div className={classes.form}>
            <SelectInput label="Frecuencia" value={params.frequency} name="frequency" onChange={this.handleChange}
              options={[
                { value: 2, label: "Sin frecuencia" },
                { value: 1, label: "Solo una vez" },
                { value: 30, label: "Mensual" },
                { value: 365, label: "Anual" }
              ]}
            />
          </div>
          <div className={classes.form}>
            <TextInput
              label={`${params.frequency === 365 ? "Mes" : "Día"} de corte (en número)`}
              value={params.cut_day}
              disabled={!params.frequency || params.frequency < 30}
              name="cut_day"
              onChange={this.handleChange}
              type="number"
            />
            <Button variant="outlined" color="primary" onClick={this.handleCreate} disabled={!params.name}>
              <Add />
            </Button>
          </div>
        </Paper>

        <div className={classes.card}>
          <Typography className={classes.subtitle} variant="h2">Carpetas</Typography>
          {loading ?
            <div className={classes.loaderContainer}>
              <LoaderAnimator loading={loading} />
            </div>
            :
            <div className={classes.categories}>
              {this.renderCategories()}
            </div>
          }
        </div>
        <Dialog open={openDialog} onClose={this.handleOpenDialog} fullWidth maxWidth="sm">
          <Typography variant="h2" className={classes.subtitle}>Editar Carpeta</Typography>
          <div className={classes.dialogForm}>
            <TextInput label="Nuevo nombre" value={editParams.name} name="name" onChange={this.handleChangeEdit} />
            <SelectInput label="Frecuencia" value={editParams.frequency} name="frequency" onChange={this.handleChangeEdit}
              options={[
                { value: 2, label: "Sin frecuencia" },
                { value: 1, label: "Solo una vez" },
                { value: 30, label: "Mensual" },
                { value: 365, label: "Anual" }
              ]} />
            <TextInput
              label={`${editParams.frequency === 365 ? "Mes" : "Día"} de corte (en número)`}
              value={editParams.cut_day}
              disabled={!editParams.frequency || editParams.frequency < 30}
              name="cut_day"
              onChange={this.handleChangeEdit}
              type="number"
            />
            <SubmitButton onClick={this.handleSaveEdit}>
              Guardar
            </SubmitButton>
          </div>
        </Dialog>
        <Dialog open={openWarning} onClose={this.handleOpenWarning} fullWidth maxWidth="sm">
          <Typography variant="h2" className={classes.subtitle}>Eliminar Carpeta</Typography>
          <div className={classes.dialogForm}>
            <Typography variant="subtitle1">¿Seguro que desea eliminar este elemento?</Typography>
            <Typography variant="subtitle1">Carpeta: {category.name}</Typography>
            <div className={classes.submitButtons}>
              <Button color="primary" variant="outlined" size="small" onClick={this.handleOpenWarning}>
                Cancelar
              </Button>
              <Button color="primary" variant="contained" size="small" onClick={this.handleSendDelete}>
                Eliminar
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings
})

const mapDispatchToProps = dispatch => ({
  getSettingsEnterpriseCategories: () => dispatch(getSettingsEnterpriseCategoriesAction()),
  createSettingsEnterpriseCategory: body => dispatch(createSettingsEnterpriseCategoryAction(body)),
  editSettingsEnterpriseCategory: body => dispatch(editSettingsEnterpriseCategoryAction(body)),
  deleteSettingsEnterpriseCategory: body => dispatch(deleteSettingsEnterpriseCategoryAction(body))
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(EnterpriseDocuments))